import { calendar, car, location } from "../assets/images";

export const how = [
  {
    img: location,
    title: "Select A Vehicle",
    desc: "Choose your location and find your best car",
  },
  {
    img: calendar,
    title: "Pick-up Date/Time",
    desc: "Select your pick up date and time to book your car",
  },
  {
    img: car,
    title: "Drive Your Vehicle",
    desc: "Have a contactless exchange, and unlock the vehicle.",
  },
];
